<template>
    <span v-if="html" v-html="getTranslation()"></span>
    <span v-else>{{getTranslation()}}</span>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "Translate",
        props: ['data', 'html'],
        computed: {
            ...mapGetters('Language', ['currentLanguageIso']),
        },
        methods: {
            getTranslation(){
                try {
                    let dataObject = JSON.parse(this.data);
                    if( typeof this.currentLanguageIso !== 'undefined' && this.currentLanguageIso !== null) {
                        if (typeof dataObject[this.currentLanguageIso] !== 'undefined' && dataObject[this.currentLanguageIso] !== null ) {
                            return dataObject[this.currentLanguageIso];
                        }
                    }
                    let keys = Object.keys(dataObject);
                    if (keys.length > 0) {
                        return dataObject[Object.keys(dataObject)[0]];
                    }
                    return this.data;
                } catch (e) {
                    return this.data;
                }
            }
        }
    }
</script>

<style scoped>

</style>
